<template>
  <div class="test-drive-statistics">
    <div class="main-content">
      <div class="filter-section">
        <div class="filter-form">
          <div class="filter-item">
            <a-input
              v-model:value="filters.searchText"
              placeholder="搜索品牌、车型、车牌号、车架号"
              allowClear
              @change="handleSearchChange"
            >
              <a-icon type="search" slot="prefix" />
            </a-input>
          </div>
        </div>
        <div class="filter-actions">
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button @click="handleReset">重置</a-button>
        </div>
      </div>

      <div class="action-bar">
        <a-button type="primary" @click="handleAddVehicle">
          + 新增车辆
        </a-button>
      </div>

      <div class="table-section">
        <vxe-table
          ref="vxeTableRef"
          :data="filteredData"
          auto-resize
          :column-config="{ resizable: true }"
          :row-config="{ isHover: true, height: 40 }"
          :show-overflow="'title'"
        >
          <vxe-column type="seq" width="60" title="序号" fixed="left" />
          <vxe-column field="brand" title="品牌名称" min-width="100" fixed="left" />
          <vxe-column field="model" title="车型" min-width="120" />
          <vxe-column field="plate" title="车牌号" min-width="120">
            <template #default="{ row }">
              <span class="plate-text">{{ row.plate || '--' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="vin" title="车架号" min-width="160" />
          <vxe-column field="batteryModel" title="电池型号" min-width="140" />
          <vxe-column field="batteryCapacity" title="电池容量" min-width="120" />
          <vxe-column field="soh" title="SOH" min-width="80" />
          <vxe-column field="route" title="关联线路" min-width="180">
            <template #default="{ row }">
              <a-tag v-for="(r, index) in (row.route || '').split(',').filter(v => v.trim())" :key="index" color="blue">
                {{ r.trim() }}
              </a-tag>
              <span v-if="!(row.route && row.route.trim())">--</span>
            </template>
          </vxe-column>
          <vxe-column field="note" title="备注" min-width="120" />
          <vxe-column title="操作" width="auto" fixed="right" align="right">
            <template #default="{ row }">
              <button class="link-button qr-btn" @click="handleRouteQR(row)">路线码</button>
              <button class="link-button qr-btn" @click="handleChargeQR(row)">充电码</button>
              <button class="link-button" @click="handleEditVehicle(row)">编辑</button>
              <button class="link-button" @click="handleViewVehicle(row)">查看</button>
              <button class="link-button danger" @click="handleDelete(row)">删除</button>
            </template>
          </vxe-column>
        </vxe-table>

        <div class="pagination-wrapper">
          <a-pagination
            v-model:current="currentPage"
            :page-size="pageSize"
            :page-size-options="['10', '20', '50', '100']"
            :total="filteredData.length"
            :showSizeChanger="true"
            :showQuickJumper="true"
            :showTotal="showTotalText"
            @change="handlePageChange"
            @showSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>

    <!-- 新增/编辑车辆抽屉 -->
    <Drawer :visible="drawerVisible" @update:visible="drawerVisible = $event">
      <template #title>
        <span class="drawer-title-text">{{ isEdit ? '编辑车辆' : '新增车辆' }}</span>
      </template>
      <div class="drawer-content">
        <a-form :form="vehicleForm" layout="vertical">
          <div class="form-grid">
            <div class="form-grid-item">
              <a-form-item label="品牌名称" required>
                <a-select
                  v-decorator="['brand', { rules: [{ required: true, message: '请选择品牌名称' }] }]"
                  placeholder="请选择品牌名称"
                  @change="handleBrandChange"
                >
                  <a-select-option value="三一">三一</a-select-option>
                  <a-select-option value="徐工">徐工</a-select-option>
                  <a-select-option value="深向">深向</a-select-option>
                  <a-select-option value="长城">长城</a-select-option>
                  <a-select-option value="陕汽">陕汽</a-select-option>
                  <a-select-option value="福田">福田</a-select-option>
                  <a-select-option value="江淮">江淮</a-select-option>
                  <a-select-option value="联合">联合</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="车型" required>
                <a-select
                  v-decorator="['model', { rules: [{ required: true, message: '请选择车型' }] }]"
                  placeholder="请先选择品牌名称"
                  :disabled="!selectedBrand"
                >
                  <a-select-option v-for="m in modelOptions" :key="m" :value="m">{{ m }}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="车牌号" required>
                <a-input
                  v-decorator="['plate', { rules: [{ required: true, message: '请输入车牌号' }] }]"
                  placeholder="请输入车牌号"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="车架号" required>
                <a-input
                  v-decorator="['vin', { rules: [{ required: true, message: '请输入车架号' }] }]"
                  placeholder="请输入车架号"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="电池型号" required>
                <a-input
                  v-decorator="['batteryModel', { rules: [{ required: true, message: '请输入电池型号' }] }]"
                  placeholder="请输入电池型号"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="电池容量" required>
                <a-input
                  v-decorator="['batteryCapacity', { rules: [{ required: true, message: '请输入电池容量' }] }]"
                  placeholder="请输入电池容量"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="SOH" required>
                <a-input
                  v-decorator="['soh', { rules: [{ required: true, message: '请输入SOH' }] }]"
                  placeholder="请输入SOH"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item full-width">
              <a-form-item label="关联线路" required>
                <a-select
                  v-decorator="['route', { rules: [{ required: true, message: '请选择关联线路' }] }]"
                  mode="multiple"
                  placeholder="请选择关联线路"
                >
                  <a-select-option v-for="r in routeOptions" :key="r" :value="r">{{ r }}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="form-grid-item full-width">
              <a-form-item label="备注">
                <a-textarea
                  v-decorator="['note']"
                  placeholder="请输入备注"
                  style="height: 80px; resize: none;"
                />
              </a-form-item>
            </div>
          </div>
        </a-form>
        <div class="form-actions">
          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary" @click="handleSubmitVehicle" :loading="submitLoading">{{ submitLoading ? (isEdit ? '保存中...' : '提交中...') : (isEdit ? '保存' : '确定') }}</a-button>
        </div>
      </div>
    </Drawer>

    <!-- 查看车辆抽屉 -->
    <Drawer :visible="viewModalVisible" @update:visible="viewModalVisible = $event" width="500px">
      <template #title>
        <span class="drawer-title-text">查看车辆</span>
      </template>
      <div class="drawer-content">
        <!-- 车辆基本信息 -->
        <div class="view-section">
          <div class="view-section-title">车辆信息</div>
          <div class="view-info-card">
            <div class="view-info-grid">
              <div class="view-info-item">
                <span class="view-info-label">品牌名称</span>
                <span class="view-info-value">{{ viewModalData.brand || '--' }}</span>
              </div>
              <div class="view-info-item">
                <span class="view-info-label">车型</span>
                <span class="view-info-value">{{ viewModalData.model || '--' }}</span>
              </div>
              <div class="view-info-item">
                <span class="view-info-label">车牌号</span>
                <span class="view-info-value">{{ viewModalData.plate || '--' }}</span>
              </div>
              <div class="view-info-item">
                <span class="view-info-label">车架号</span>
                <span class="view-info-value">{{ viewModalData.vin || '--' }}</span>
              </div>
              <div class="view-info-item">
                <span class="view-info-label">电池型号</span>
                <span class="view-info-value">{{ viewModalData.batteryModel || '--' }}</span>
              </div>
              <div class="view-info-item">
                <span class="view-info-label">电池容量</span>
                <span class="view-info-value">{{ viewModalData.batteryCapacity || '--' }}</span>
              </div>
              <div class="view-info-item">
                <span class="view-info-label">SOH</span>
                <span class="view-info-value">{{ viewModalData.soh || '--' }}</span>
              </div>
              <div class="view-info-item">
                <span class="view-info-label">关联线路</span>
                <span class="view-info-value">
                  <a-tag v-for="(r, index) in (viewModalData.route || '').split(',').filter(v => v.trim())" :key="index" color="blue">
                    {{ r.trim() }}
                  </a-tag>
                  <span v-if="!(viewModalData.route && viewModalData.route.trim())">--</span>
                </span>
              </div>
              <div class="view-info-item full-width">
                <span class="view-info-label">备注</span>
                <span class="view-info-value">{{ viewModalData.note || '--' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 充电记录/跑线路记录 tabs -->
        <div class="view-section">
          <a-tabs type="card" :activeKey="viewActiveTab" @change="handleViewTabChange" class="view-tabs">
            <a-tab-pane key="charge" tab="充电记录">
              <vxe-table
                v-if="viewModalData.chargeRecords && viewModalData.chargeRecords.length"
                :data="viewModalData.chargeRecords"
                :column-config="{ resizable: true }"
                :scroll-y="{ enabled: true }"
                border
                size="small"
                max-height="400"
              >
                <vxe-column type="seq" width="60" title="序号" fixed="left" />
                <vxe-column field="chargeTime" title="充电时间" width="150" fixed="left" />
                <vxe-column field="kwhBefore" title="充电前电量" width="100">
                  <template #default="{ row }">
                    {{ row.kwhBefore || '45' }}%
                  </template>
                </vxe-column>
                <vxe-column field="kwhAfter" title="充电后电量" width="100">
                  <template #default="{ row }">
                    {{ row.kwhAfter || '95' }}%
                  </template>
                </vxe-column>
                <vxe-column field="price" title="充电价格" width="100" align="right">
                  <template #default="{ row }">
                    <span class="charge-price">¥{{ row.price || '128.50' }}</span>
                  </template>
                </vxe-column>
                <vxe-column field="duration" title="充电时长" width="80">
                  <template #default="{ row }">
                    {{ row.duration || '2.5' }}h
                  </template>
                </vxe-column>
                <vxe-column field="address" title="充电地址" min-width="200" />
                <vxe-column title="付款凭证" width="180">
                  <template #default="{ row }">
                    <div class="table-photos" v-if="row.payPhotos && row.payPhotos.length">
                      <img 
                        v-for="(photo, idx) in row.payPhotos.slice(0, 3)" 
                        :key="idx" 
                        :src="photo" 
                        class="table-photo-thumb"
                        @click="previewImage(photo)"
                      >
                      <span v-if="row.payPhotos.length > 3" class="photo-more">+{{ row.payPhotos.length - 3 }}</span>
                    </div>
                    <span v-else>--</span>
                  </template>
                </vxe-column>
                <vxe-column title="仪表盘照片" width="180">
                  <template #default="{ row }">
                    <div class="table-photos" v-if="row.dashPhotos && row.dashPhotos.length">
                      <img 
                        v-for="(photo, idx) in row.dashPhotos.slice(0, 3)" 
                        :key="idx" 
                        :src="photo" 
                        class="table-photo-thumb"
                        @click="previewImage(photo)"
                      >
                      <span v-if="row.dashPhotos.length > 3" class="photo-more">+{{ row.dashPhotos.length - 3 }}</span>
                    </div>
                    <span v-else>--</span>
                  </template>
                </vxe-column>
              </vxe-table>
              <div class="empty-record" v-else>
                <a-empty description="暂无充电记录" :image="simpleImage" />
              </div>
            </a-tab-pane>
            <a-tab-pane key="route" tab="跑线路记录">
              <vxe-table
                v-if="viewModalData.routeRecords && viewModalData.routeRecords.length"
                :data="viewModalData.routeRecords"
                :column-config="{ resizable: true }"
                :scroll-y="{ enabled: true }"
                border
                size="small"
                max-height="400"
              >
                <vxe-column type="seq" width="60" title="序号" fixed="left" />
                <vxe-column field="line" title="线路" width="140" fixed="left" />
                <vxe-column field="mileage" title="当前里程表（公里）" width="140">
                  <template #default="{ row }">
                    {{ row.mileage || '0' }} km
                  </template>
                </vxe-column>
                <vxe-column field="battery" title="当前电量（%）" width="100">
                  <template #default="{ row }">
                    {{ row.battery || '0' }}%
                  </template>
                </vxe-column>
                <vxe-column field="cargoWeight" title="货重（吨）" width="100">
                  <template #default="{ row }">
                    {{ row.cargoWeight || '0' }}
                  </template>
                </vxe-column>
                <vxe-column field="tollFee" title="过路费（元）" width="100" align="right">
                  <template #default="{ row }">
                    ¥{{ row.tollFee || '0' }}
                  </template>
                </vxe-column>
                <vxe-column field="remark" title="备注" min-width="160" />
                <vxe-column title="仪表盘照片" width="180">
                  <template #default="{ row }">
                    <div class="table-photos" v-if="row.dashPhotos && row.dashPhotos.length">
                      <img 
                        v-for="(photo, idx) in row.dashPhotos.slice(0, 3)" 
                        :key="idx" 
                        :src="photo" 
                        class="table-photo-thumb"
                        @click="previewImage(photo)"
                      >
                      <span v-if="row.dashPhotos.length > 3" class="photo-more">+{{ row.dashPhotos.length - 3 }}</span>
                    </div>
                    <span v-else>--</span>
                  </template>
                </vxe-column>
              </vxe-table>
              <div class="empty-record" v-else>
                <a-empty description="暂无跑线路记录" :image="simpleImage" />
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </Drawer>

    <!-- 图片预览弹窗 -->
    <a-modal
      :visible="imagePreviewVisible"
      :footer="null"
      width="700px"
      centered
      @cancel="imagePreviewVisible = false"
    >
      <template #title>图片预览</template>
      <div style="text-align: center;">
        <img :src="imagePreviewUrl" style="max-width: 100%; max-height: 60vh;" />
      </div>
    </a-modal>

    <!-- 二维码弹窗 -->
    <a-modal
      :visible="qrModalVisible"
      :footer="null"
      width="460px"
      :closable="true"
      centered
      @cancel="qrModalVisible = false"
      wrapClassName="qr-modal-wrapper"
    >
      <template #title>
        <span class="qr-modal-title">{{ qrModalType === 'charge' ? '充电码' : '路线码' }}</span>
      </template>
      <div class="qr-modal-content">
        <div ref="qrDownloadRef" class="qr-download-area">
          <div class="qr-download-card">
          <!-- 顶部品牌区 -->
          <div class="qr-brand-header">
            <div class="qr-brand-tag">
              <a-icon :type="qrModalType === 'charge' ? 'thunderbolt' : 'environment'" />
              <span>{{ qrModalType === 'charge' ? '车辆充电' : '跑线路登记' }}</span>
            </div>
          </div>

          <!-- 二维码区 -->
          <div class="qr-image-wrapper">
            <div class="qr-image-frame">
              <img :src="qrImageUrl" alt="二维码" class="qr-image" ref="qrImageRef" />
              <div class="qr-corner qr-corner-tl"></div>
              <div class="qr-corner qr-corner-tr"></div>
              <div class="qr-corner qr-corner-bl"></div>
              <div class="qr-corner qr-corner-br"></div>
            </div>
          </div>

          <!-- 扫码提示 -->
          <div class="qr-scan-tip">
            <div class="qr-scan-tip-title">
              <span class="qr-scan-line qr-scan-line-left"></span>
              <span>{{ qrModalType === 'charge' ? '扫码登记充电信息' : '扫码登记路线信息' }}</span>
              <span class="qr-scan-line qr-scan-line-right"></span>
            </div>
            <div class="qr-scan-tip-desc">可长按识别二维码进入</div>
          </div>

          <!-- 字段卡片 -->
          <div class="qr-info-card qr-plate-card">
            <div class="qr-plate-value">{{ qrModalData.plate || '--' }}</div>
          </div>

          <!-- 数据采集说明 -->
          <div class="qr-collect-box">
            <div class="qr-collect-icon">
              <a-icon type="edit" />
            </div>
            <div class="qr-collect-text">
              <div class="qr-collect-title">{{ qrModalType === 'charge' ? '实时充电登记' : '跑线路登记' }}</div>
              <div class="qr-collect-desc">{{ qrModalType === 'charge' ? '扫码后填写充电信息。' : '扫码后填写跑线路信息。' }}</div>
            </div>
          </div>

          <!-- 底部品牌区 -->
          <div class="qr-brand-footer">
            <div class="qr-footer-left">{{ qrModalType === 'charge' ? '车辆充电系统' : '跑线路登记系统' }}</div>
            <div class="qr-footer-tag">数据加密·安全可靠</div>
          </div>
          </div>
        </div>
        <div class="qr-modal-actions">
          <a-button type="primary" size="large" block @click="handleDownloadQRImage">
            <a-icon type="download" /> 下载二维码
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Drawer from '../components/Drawer.vue'
import html2canvas from 'html2canvas'

const VEHICLE_KEY = 'vehicle_data'
const ROUTE_KEY = 'route_data'
const CHARGE_RECORD_KEY = 'charge_record_data'
const ROUTE_RECORD_KEY = 'route_record_data'

export default {
  name: 'TestDriveStatistics',
  components: {
    Drawer
  },
  data() {
    return {
      filters: {
        searchText: ''
      },
      currentPage: 1,
      pageSize: 10,
      drawerVisible: false,
      isEdit: false,
      editingRow: null,
      submitLoading: false,
      qrModalVisible: false,
      qrModalType: 'charge',
      qrModalData: {},
      qrImageUrl: '',
      vehicleForm: this.$form.createForm(this),
      selectedBrand: null,
      modelOptions: [],
      brandModelMap: {
        '三一': ['重卡H8', '重卡H6', '电动重卡'],
        '徐工': ['汉风G7', '汉风G9', '电动牵引车'],
        '深向': ['智能重卡', '自动驾驶卡车'],
        '长城': ['炮系列', '欧拉', '电动皮卡'],
        '陕汽': ['德龙X3000', '德龙M3000', '新能源重卡'],
        '福田': ['欧曼GTL', '欧曼EST', '智蓝新能源'],
        '江淮': ['格尔发K7', '格尔发K5', '新能源商用车'],
        '联合': ['联合U系', '联合V系', '电动重卡']
      },
      viewModalVisible: false,
      viewActiveTab: 'charge',
      viewModalData: {},
      simpleImage: 'https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLjJCYwAAAAAAAAAAARjAQQ',
      imagePreviewVisible: false,
      imagePreviewUrl: '',
      tableData: [
        {
          id: 1,
          brand: '三一',
          model: '重卡H8',
          plate: '浙A·12345',
          vin: 'LSGGD53N0KF001234',
          batteryModel: '宁德时代NCM811',
          batteryCapacity: '282 kWh',
          soh: '95%',
          route: '萧山-黄山,杭州-黄山',
          note: ''
        },
        {
          id: 2,
          brand: '徐工',
          model: '汉风G7',
          plate: '浙A·23456',
          vin: 'LXGGA53N0KF002345',
          batteryModel: '宁德时代NCM622',
          batteryCapacity: '250 kWh',
          soh: '92%',
          route: '上海-黄山',
          note: ''
        },
        {
          id: 3,
          brand: '深向',
          model: '智能重卡',
          plate: '沪A·34567',
          vin: 'LSJGA53N0KF003456',
          batteryModel: '亿纬锂能',
          batteryCapacity: '300 kWh',
          soh: '88%',
          route: '宁波-黄山,温州-黄山',
          note: '电量异常'
        },
        {
          id: 4,
          brand: '长城',
          model: '炮系列',
          plate: '浙B·45678',
          vin: 'LGWGA53N0KF004567',
          batteryModel: '蜂巢能源',
          batteryCapacity: '180 kWh',
          soh: '96%',
          route: '黄山-杭州',
          note: ''
        },
        {
          id: 5,
          brand: '陕汽',
          model: '德龙X3000',
          plate: '陕A·56789',
          vin: 'LSHGA53N0KF005678',
          batteryModel: '宁德时代NCM811',
          batteryCapacity: '320 kWh',
          soh: '90%',
          route: '萧山-黄山,黄山-上海',
          note: ''
        }
      ]
    }
  },
  mounted() {
    this.loadVehicleData()
  },
  computed: {
    routeOptions() {
      return this.getRouteOptions()
    },
    filteredData() {
      let data = [...this.tableData]
      
      if (this.filters.searchText) {
        const search = this.filters.searchText.toLowerCase()
        data = data.filter(item => 
          item.brand.toLowerCase().includes(search) || 
          item.model.toLowerCase().includes(search) ||
          item.plate.toLowerCase().includes(search) ||
          item.vin.toLowerCase().includes(search)
        )
      }
      
      return data
    }
  },
  methods: {
    showTotalText(total) {
      return `共 ${total} 条`
    },
    loadVehicleData() {
      try {
        const data = localStorage.getItem(VEHICLE_KEY)
        if (data) {
          this.tableData = JSON.parse(data)
        }
      } catch (e) {
        console.error('加载车辆数据失败:', e)
      }
    },
    saveVehicleData() {
      try {
        localStorage.setItem(VEHICLE_KEY, JSON.stringify(this.tableData))
      } catch (e) {
        console.error('保存车辆数据失败:', e)
      }
    },
    getRouteOptions() {
      try {
        const data = localStorage.getItem(ROUTE_KEY)
        if (data) {
          const routes = JSON.parse(data)
          return routes.map(r => r.name).filter(Boolean)
        }
      } catch (e) {
        console.error('加载线路数据失败:', e)
      }
      return []
    },
    handleSearch() {
      this.currentPage = 1
    },
    handleSearchChange() {
      this.handleSearch()
    },
    handleReset() {
      this.filters = {
        searchText: ''
      }
      this.currentPage = 1
    },
    handleSizeChange(current, size) {
      this.pageSize = size
      this.currentPage = 1
    },
    handlePageChange(page) {
      this.currentPage = page
    },
    handleAddVehicle() {
      this.vehicleForm.resetFields()
      this.selectedBrand = null
      this.modelOptions = []
      this.isEdit = false
      this.editingRow = null
      this.drawerVisible = true
    },
    handleViewTabChange(key) {
      this.viewActiveTab = key
    },
    handleViewVehicle(row) {
      // 模拟跑线路记录数据
      const mockRouteRecords = [
        {
          line: '萧山-黄山',
          mileage: '12580',
          battery: '85',
          cargoWeight: '8.5',
          tollFee: '120',
          remark: '运输顺利，客户已签收',
          dashPhotos: [
            'https://img.freepik.com/free-photo/car-dashboard_144627-16843.jpg?w=200',
            'https://img.freepik.com/free-photo/vehicle-meter-display_144627-38256.jpg?w=200'
          ]
        },
        {
          line: '黄山-萧山',
          mileage: '12860',
          battery: '45',
          cargoWeight: '10',
          tollFee: '135',
          remark: '回程空车',
          dashPhotos: [
            'https://img.freepik.com/free-photo/car-speedometer-odometer_144627-16845.jpg?w=200'
          ]
        },
        {
          line: '杭州-黄山',
          mileage: '13250',
          battery: '90',
          cargoWeight: '12',
          tollFee: '110',
          remark: '满载运输',
          dashPhotos: [
            'https://img.freepik.com/free-photo/electric-vehicle-charging_23-2149311605.jpg?w=200'
          ]
        }
      ]
      // 模拟充电记录数据，实际项目中应该从服务器获取
      const mockChargeRecords = [
        {
          chargeTime: '2024-01-15 14:30',
          kwhBefore: '45',
          kwhAfter: '95',
          price: '128.50',
          duration: '2.5',
          address: '深圳市南山区科技园充电站',
          payPhotos: [
            'https://img.freepik.com/free-photo/receipt-paper-texture_1194-7533.jpg?w=200',
            'https://img.freepik.com/free-photo/invoice-bill-paper_1388-1344.jpg?w=200'
          ],
          dashPhotos: [
            'https://img.freepik.com/free-photo/car-dashboard_144627-16843.jpg?w=200',
            'https://img.freepik.com/free-photo/vehicle-meter-display_144627-38256.jpg?w=200'
          ]
        },
        {
          chargeTime: '2024-01-10 09:15',
          kwhBefore: '30',
          kwhAfter: '100',
          price: '186.00',
          duration: '3.5',
          address: '广州市天河区新能源充电中心',
          payPhotos: [
            'https://img.freepik.com/free-photo/payment-receipt-concept_23-2148584101.jpg?w=200'
          ],
          dashPhotos: [
            'https://img.freepik.com/free-photo/car-speedometer-odometer_144627-16845.jpg?w=200',
            'https://img.freepik.com/free-photo/electric-vehicle-charging_23-2149311605.jpg?w=200',
            'https://img.freepik.com/free-photo/ev-charging-station_23-2149311603.jpg?w=200'
          ]
        }
      ]
      
      this.viewModalData = {
        ...row,
        chargeRecords: mockChargeRecords,
        routeRecords: mockRouteRecords
      }
      this.viewModalVisible = true
    },
    previewImage(url) {
      this.imagePreviewUrl = url
      this.imagePreviewVisible = true
    },
    handleBrandChange(value) {
      this.selectedBrand = value
      this.modelOptions = this.brandModelMap[value] || []
      this.vehicleForm.setFieldsValue({ model: undefined })
    },
    handleEditVehicle(row) {
      this.vehicleForm.resetFields()
      this.selectedBrand = row.brand
      this.modelOptions = this.brandModelMap[row.brand] || []
      this.editingRow = row
      this.isEdit = true
      this.drawerVisible = true
      
      this.vehicleForm.setFieldsValue({
        brand: row.brand,
        model: row.model,
        plate: row.plate,
        vin: row.vin,
        batteryModel: row.batteryModel,
        batteryCapacity: row.batteryCapacity,
        soh: row.soh,
        route: row.route ? row.route.split(',').map(r => r.trim()).filter(r => r) : [],
        note: row.note
      })
    },
    handleCancel() {
      this.drawerVisible = false
      this.vehicleForm.resetFields()
    },
    handleSubmitVehicle() {
      this.vehicleForm.validateFields((err, values) => {
        if (!err) {
          this.submitLoading = true
          setTimeout(() => {
            const routeStr = Array.isArray(values.route) ? values.route.join(',') : values.route
            
            if (this.isEdit) {
              const index = this.tableData.findIndex(item => item.id === this.editingRow.id)
              if (index > -1) {
                this.tableData.splice(index, 1, {
                  ...this.editingRow,
                  ...values,
                  route: routeStr
                })
              }
            } else {
              const newRecord = {
                id: Date.now(),
                ...values,
                route: routeStr
              }
              this.tableData.unshift(newRecord)
            }

            this.saveVehicleData()
            this.$message.success(this.isEdit ? '保存成功' : '新增成功')
            this.submitLoading = false
            this.drawerVisible = false
          }, 500)
        }
      })
    },
    handleChargeQR(row) {
      // 生成二维码数据，包含移动端需要的所有字段信息
      const qrData = {
        id: row.id,
        brand: row.brand,
        model: row.model,
        plate: row.plate,
        vin: row.vin,
        batteryModel: row.batteryModel,
        batteryCapacity: row.batteryCapacity,
        soh: row.soh,
        route: row.route,
        note: row.note,
        timestamp: Date.now()
      }
      const qrString = JSON.stringify(qrData)
      const encodedData = encodeURIComponent(qrString)
      const qrUrl = `${window.location.origin}/移动端充电.html?data=${encodedData}`
      
      this.qrModalType = 'charge'
      this.qrModalData = {
        brand: row.brand,
        model: row.model,
        plate: row.plate,
        vin: row.vin,
        batteryModel: row.batteryModel,
        batteryCapacity: row.batteryCapacity,
        soh: row.soh,
        route: row.route,
        note: row.note,
        url: qrUrl
      }
      
      // 直接设置二维码图片URL
      this.qrImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=256x256&data=${encodeURIComponent(qrUrl)}`
      
      this.qrModalVisible = true
    },
    handleRouteQR(row) {
      this.qrModalType = 'route'
      this.showQRModal(row)
    },
    showQRModal(row) {
      let qrUrl = ''
      if (this.qrModalType === 'charge') {
        // 充电码：绑定车辆基础信息（用于移动端充电.html）
        const qrData = {
          id: row.id,
          brand: row.brand,
          model: row.model,
          plate: row.plate,
          vin: row.vin,
          batteryModel: row.batteryModel,
          batteryCapacity: row.batteryCapacity,
          soh: row.soh,
          route: row.route,
          note: row.note,
          timestamp: Date.now()
        }
        const qrString = JSON.stringify(qrData)
        const encodedData = encodeURIComponent(qrString)
        qrUrl = `${window.location.origin}/移动端充电.html?data=${encodedData}`
      } else {
        // 路线码：绑定移动端路线.html所需的所有字段
        const qrData = {
          id: row.id,
          brand: row.brand,
          model: row.model,
          plate: row.plate,
          vin: row.vin,
          route: row.route,
          // 移动端路线登记字段（初始为空）
          line: '',
          mileage: '',
          battery: '',
          cargoWeight: '',
          tollFee: '',
          dashPhotos: [],
          remark: '',
          timestamp: Date.now()
        }
        const qrString = JSON.stringify(qrData)
        const encodedData = encodeURIComponent(qrString)
        qrUrl = `${window.location.origin}/移动端路线.html?data=${encodedData}`
      }

      this.qrModalData = {
        brand: row.brand,
        model: row.model,
        plate: row.plate,
        route: row.route,
        url: qrUrl
      }
      this.qrImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=256x256&data=${encodeURIComponent(qrUrl)}`
      this.qrModalVisible = true
    },
    handleCopyQR() {
      if (this.qrModalData.url) {
        this.$copyText(this.qrModalData.url).then(() => {
          this.$message.success('链接已复制到剪贴板')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      }
    },
    async handleDownloadQRImage() {
      const target = this.$refs.qrDownloadRef
      if (!target) {
        this.$message.error('二维码未加载完成')
        return
      }
      try {
        this.$message.loading('正在生成图片...', 0)
        const canvas = await html2canvas(target, {
          backgroundColor: '#ffffff',
          scale: window.devicePixelRatio * 4 || 4,
          useCORS: true,
          allowTaint: true,
          logging: false,
          imageTimeout: 0,
          removeContainer: false
        })
        this.$message.destroy()
        canvas.toBlob((blob) => {
          if (!blob) {
            this.$message.error('图片生成失败')
            return
          }
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = `${this.qrModalType === 'charge' ? '充电码' : '路线码'}_${this.qrModalData.plate || '二维码'}_${Date.now()}.png`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
          this.$message.success('二维码下载成功')
        }, 'image/png')
      } catch (e) {
        this.$message.destroy()
        this.$message.error('下载失败：' + (e.message || '未知错误'))
      }
    },
    handleDelete(row) {
      this.$confirm({
        title: '确认删除',
        content: `确定要删除这辆车吗？`,
        okText: '确定',
        cancelText: '取消',
        icon: 'exclamation-circle',
        onOk: () => {
          const index = this.tableData.findIndex(item => item.id === row.id)
          if (index > -1) {
            this.tableData.splice(index, 1)
            this.saveVehicleData()
            this.$message.success('删除成功')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.test-drive-statistics {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f2f3f5;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 24px;
  overflow: auto;
}

.filter-section {
  display: flex;
  align-items: center;
  column-gap: 16px;
  border: 1px solid #D7D7DB;
  border-radius: 8px;
  background: #F7F8FA;
  padding: 23px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  flex-shrink: 0;
}

.filter-form {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  flex: 1;
}

.filter-item {
  min-width: 200px;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.filter-item :deep(.ant-select),
.filter-item :deep(.ant-input),
.filter-item :deep(.ant-cascader) {
  width: 100% !important;
  display: block !important;
}

.action-bar {
  padding: 0;
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.table-section {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.link-button {
  background: none;
  border: none;
  color: #516EFD;
  cursor: pointer;
  padding: 0 4px;
  font-size: 14px;
  outline: none;
}

.link-button:hover {
  color: #4058E8;
}

.link-button:active {
  color: #3A4FBF;
}

.link-button.danger {
  color: #516EFD;
}

.link-button.danger:hover {
  color: #3A5CE4;
}

.link-button.danger:active {
  color: #284FCC;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.drawer-content {

}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 16px;
  column-gap: 16px;
}

.form-grid-item {
  display: flex;
  flex-direction: column;
}

.form-grid-item .ant-form-item {
  margin-bottom: 0;
}

.form-grid-item .ant-form-item-label {
  padding-bottom: 4px;
}

.form-grid-item .ant-form-item-control-input {
  min-height: auto;
}

.form-grid-item .ant-input,
.form-grid-item .ant-select-selector,
.form-grid-item .ant-input-affix-wrapper {
  padding: 0 8px;
}

.form-grid-item.full-width {
  grid-column: 1 / -1;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}

.plate-text {
  font-family: Arial Black, Microsoft YaHei;
  font-weight: 600;
  font-size: 14px;
  color: #0DD78D;
  letter-spacing: 1px;
}

.lightning-icon {
  font-size: 14px;
  margin-right: 4px;
  color: #0DD78D;
}

.drawer-title-text {
  font-weight: 600;
}

/* ========== 二维码弹窗样式 ========== */

/* 弹窗头部 */
.qr-modal-wrapper /deep/ .ant-modal-header {
  background: #F2F3F5 !important;
  background-color: #F2F3F5 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  padding: 14px 24px !important;
}

.qr-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #1B1C33;
}

/* 弹窗内容区 */
.qr-modal-content {
  padding: 0;
}

/* 下载区域 */
.qr-download-area {
  background: transparent;
  padding: 24px;
}

/* 下载卡片 */
.qr-download-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #DCE8E0;
  box-shadow: 0 4px 20px rgba(31, 95, 79, 0.06);
}

/* 顶部品牌区 */
.qr-brand-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  background: #fff;
}

.qr-brand-info {
  flex: 1;
  min-width: 0;
}

.qr-brand-name {
  font-size: 18px;
  font-weight: 700;
  color: #1F5F4F;
  line-height: 1.4;
  margin-bottom: 4px;
}

.qr-brand-subtitle {
  font-size: 12px;
  color: #8B9C90;
  line-height: 1.4;
}

.qr-brand-tag {
  display: flex;
  align-items: center;
  background: #E8F0EB;
  color: #1F5F4F;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  flex-shrink: 0;
}

.qr-brand-tag .anticon {
  margin-right: 4px;
  font-size: 12px;
}

/* 二维码区 */
.qr-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 18px;
  background: #fff;
}

.qr-image-frame {
  position: relative;
  width: 180px;
  height: 180px;
  background: #fff;
  border-radius: 4px;
  padding: 12px;
  border: 1px solid #DCE8E0;
  box-shadow: 0 6px 20px rgba(31, 95, 79, 0.12);
}

.qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.qr-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  border: 2px solid #1F5F4F;
}

.qr-corner-tl { top: -2px; left: -2px; border-right: none; border-bottom: none; border-top-left-radius: 6px; }
.qr-corner-tr { top: -2px; right: -2px; border-left: none; border-bottom: none; border-top-right-radius: 6px; }
.qr-corner-bl { bottom: -2px; left: -2px; border-right: none; border-top: none; border-bottom-left-radius: 6px; }
.qr-corner-br { bottom: -2px; right: -2px; border-left: none; border-top: none; border-bottom-right-radius: 6px; }

/* 扫码提示 */
.qr-scan-tip {
  text-align: center;
  padding: 4px 20px 14px;
  background: #fff;
}

.qr-scan-tip-title {
  font-size: 15px;
  font-weight: 700;
  color: #1F5F4F;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.qr-scan-line {
  display: inline-block;
  width: 24px;
  height: 2px;
  background: #1F5F4F;
  border-radius: 1px;
  position: relative;
}

.qr-scan-line::before,
.qr-scan-line::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  background: #1F5F4F;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
}

.qr-scan-line-left {
  margin-right: 10px;
}

.qr-scan-line-left::before {
  left: 0;
}

.qr-scan-line-left::after {
  right: 0;
}

.qr-scan-line-right {
  margin-left: 10px;
}

.qr-scan-line-right::before {
  left: 0;
}

.qr-scan-line-right::after {
  right: 0;
}

.qr-scan-tip-desc {
  font-size: 12px;
  color: #8B9C90;
}

/* 字段卡片 */
.qr-info-card {
  background: #F8FBF8;
  border-radius: 10px;
  padding: 14px 18px;
  margin: 0 16px 14px;
}

.qr-plate-card {
  padding: 14px 18px;
}

.qr-plate-value {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #1F5F4F;
  letter-spacing: 1px;
}

.qr-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 26px;
  color: #1F5F4F;
}

.qr-info-row + .qr-info-row {
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #E8F0EB;
}

.qr-info-label {
  color: #8B9C90;
  font-size: 13px;
}

.qr-info-value {
  color: #1F5F4F;
  font-weight: 700;
  text-align: right;
  word-break: break-all;
  font-size: 15px;
}

/* 数据采集说明 */
.qr-collect-box {
  display: flex;
  align-items: flex-start;
  background: #F5F9F7;
  border: 1px solid #DCE8E0;
  border-radius: 10px;
  padding: 12px 14px;
  margin: 0 16px 14px;
}

.qr-collect-icon {
  width: 32px;
  height: 32px;
  background: #1F5F4F;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-right: 12px;
  flex-shrink: 0;
}

.qr-collect-text {
  flex: 1;
  min-width: 0;
}

.qr-collect-title {
  font-size: 14px;
  font-weight: 700;
  color: #1F5F4F;
  margin-bottom: 4px;
}

.qr-collect-desc {
  font-size: 12px;
  color: #8B9C90;
  line-height: 1.5;
}

/* 底部品牌区 */
.qr-brand-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  background: #fff;
  margin: 0 16px;
  border-top: 1px solid #DCE8E0;
}

.qr-footer-left {
  font-size: 12px;
  color: #8B9C90;
}

.qr-footer-tag {
  font-size: 12px;
  color: #1F5F4F;
  background: #E8F0EB;
  padding: 3px 10px;
  border-radius: 20px;
}

.qr-modal-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;
}

/* ========== 查看弹窗样式 ========== */
.view-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #1B1C33;
}

.view-modal-content {
  padding: 16px 0;
}

.view-modal-wrapper .ant-descriptions-item-label {
  background: #fafafa;
  color: #666;
  font-weight: 500;
}

.view-modal-wrapper .ant-descriptions-item-content {
  color: #333;
}

.view-modal-wrapper .ant-tag {
  margin: 2px 4px 2px 0;
}

/* ========== 查看抽屉样式 ========== */
.view-section {
  margin-bottom: 24px;
}

.view-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1B1C33;
  margin-bottom: 12px;
}

.view-tabs {
  width: 100%;
}

.view-tabs :deep(.ant-tabs-nav) {
  margin-bottom: 12px;
}

.view-tabs :deep(.ant-tabs-tab) {
  font-size: 14px;
}

.view-tabs :deep(.ant-tabs-tab:hover) {
  color: #FC6732;
}

.view-tabs :deep(.ant-tabs-tab-active) {
  border-bottom-color: transparent !important;
  color: #FC6732 !important;
}

.view-tabs :deep(.ant-tabs-tab-active .ant-tabs-tab-btn) {
  color: #FC6732 !important;
  text-shadow: none !important;
}

.view-tabs :deep(.ant-tabs-ink-bar) {
  background: #FC6732;
}

/* 字段卡片容器 */
.view-info-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 两列网格布局 */
.view-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

/* 单个字段项 */
.view-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.view-info-item.full-width {
  grid-column: 1 / -1;
}

.view-info-label {
  color: #666;
  font-size: 14px;
  flex-shrink: 0;
}

.view-info-value {
  color: #333;
  font-size: 14px;
}

.view-info-value .ant-tag {
  margin: 2px 4px 2px 0;
}

.charge-price {
  color: #F53F3F;
  font-weight: 500;
}

.empty-record {
  padding: 40px 0;
  text-align: center;
}

/* 表格内照片样式 */
.table-photos {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
}

.table-photo-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #E8E8E8;
  transition: all 0.3s;
}

.table-photo-thumb:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.photo-more {
  font-size: 12px;
  color: #999;
  margin-left: 4px;
}

/* 调整vxe-table单元格内边距 */
.view-drawer :deep(.vxe-table .vxe-body--column) {
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>

<style>
.qr-modal-wrapper .ant-modal-header,
.qr-form-modal-wrapper .ant-modal-header {
  background: #F2F3F5 !important;
  background-color: #F2F3F5 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  padding: 14px 24px !important;
}

.ant-modal-header {
  background: #F2F3F5 !important;
  background-color: #F2F3F5 !important;
}

/* 主按钮 loading 状态：品牌色变淡（冻结色） */
.ant-btn-primary.ant-btn-loading,
.ant-btn-primary.ant-btn-loading:hover,
.ant-btn-primary.ant-btn-loading:focus {
  background: #FCC9B5 !important;
  background-color: #FCC9B5 !important;
  border-color: #FCC9B5 !important;
  color: #fff !important;
  opacity: 1 !important;
}

.ant-btn-primary.ant-btn-loading::before {
  background: transparent !important;
  opacity: 1 !important;
}
</style>
